var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.5C2 4.11929 3.11929 3 4.5 3H14.5C15.8807 3 17 4.11929 17 5.5V18C17 19.3807 18.1193 20.5 19.5 20.5H4.5C3.11929 20.5 2 19.3807 2 18V5.5ZM5.75 6.75H13.25V11.75H5.75V6.75ZM13.25 14.25H5.75V16.75H13.25V14.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 8H19.5C20.8807 8 22 9.11929 22 10.5V17.375C22 18.4105 21.1605 19.25 20.125 19.25C19.0895 19.25 18.25 18.4105 18.25 17.375V8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.e33eceb4989ed74887e3278420446c07.svg";
export { ForwardRef as ReactComponent };